import React, {useState, useEffect} from 'react';
import { Link } from 'react-router-dom';
import './Hero.css';

const Hero = () => {

    const [imageLoaded, setImageLoaded] = useState(false);
    const [showContent, setShowContent] = useState(false);

    const skyImageUrl = `${process.env.PUBLIC_URL}/assets/Sky.JPG`;

    //Preload the hero image
    useEffect(() => {
        const img = new Image();
        img.src = skyImageUrl;
        img.onload = () => {
            setImageLoaded(true);
            //Small delay to ensure smooth transition
            setTimeout(() => setShowContent(true), 100);
        };

        //Handle error case
        img.onerror = () => {
            console.error('Failed to load hero image');
            setImageLoaded(true);
            setShowContent(true);
        }
    }, [skyImageUrl]);

    return (
        <section 
            id="home" 
            className='hero-section hero-padding position-relative' 
            style={{
                color: 'black',
                overflow: 'hidden',
                //add fallback background while image loads
                background: !imageLoaded ? 'linear-gradient(135deg, var(--light-blue) 0%, var(--dark-blue) 100%)' : 'transparent',
                transition: 'background 0.5s ease-in-out'
            }}
        >

            {!imageLoaded && (
                <div
                    className='position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center'
                    style={{
                        background: 'linear-gradient(135deg, var(--light-blue) 0%, var(--dark-blue) 100%)',
                        zIndex: 2
                    }}
                    >
                        <div className='text-center text-white'>
                            <div className='spinner-border mb-3' role='status' aria-label='Loading'>
                                <span className='visually-hidden'>Loading...</span>
                            </div>
                        </div>
                    </div>
            )}
            {/* Background Image With Blur Effect -only render when loaded */}
            {imageLoaded && (
                <div
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundImage: `url('${skyImageUrl}')`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        color: 'black',
                        filter: 'blur(4px)',
                        zIndex: 0,
                        overflow: 'hidden',
                    }}
                ></div>
            )}

            {/* Gradient Fade Overlay */}
            {imageLoaded && (
                <div 
                    className='hero-fade-overlay'
                    style={{
                        opacity: showContent ? 1 : 0,
                        transition: 'opacity 0.4s ease-in-out'
                    }}
                    ></div>
            )}

            <div 
                className='container position-relative' 
                style={{
                    zIndex: 1, 
                    opacity: showContent ? 1 : 0, 
                    transform: showContent ? 'translateY(0)' : 'translateY(20)', 
                    transition: 'all 0.8s ease-out'
                    }}
                >
                <div className='row'>
                    <div className='col text-center'>
                        <h1 
                            className='display-4 fw-bold'
                            style={{ 
                                textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)', 
                                color: 'white',
                                fontSize: 'clamp(2rem, 5vw, 3.5rem)',
                                marginTop: '10px'
                            }}
                        >
                            Earn Your Peer Support Certificate
                        </h1>
                        <p 
                            className='lead fw-bold mb-4'
                            style={{ 
                                textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)',
                                color: 'white',
                                fontSize: 'clamp(1rem, 3vw, 1.25rem)'
                            }}
                        >
                            <Link to="/courses" className='btn btn-dark mt-4'>Get Started</Link>
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Hero;